export const CLOSE_MESSAGE_CONFIRM = 'Выйти из процесса подписи документов? Данные, которые вы вводили, не сохранятся'
export const CLOSE_ORDERS_MESSAGE_CONFIRM = 'Выйти из процесса подписи оферты? Оферта не будет подписана'
